export default __webpack_public_path__ + "static/media/telephone_3.d25cb2a1.png";